import React from 'react';
import styled from 'styled-components';

const AboutSection = styled.section`
  padding: ${({ theme }) => `${theme.spacing['2xl']} 0`};
  background-color: ${({ theme }) => theme.colors.white};
`;

const AboutContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
`;

const TextContent = styled.div`
  h2 {
    margin-bottom: 2rem;
    color: ${({ theme }) => theme.colors.dark};
  }
  
  p {
    font-size: 1.125rem;
    line-height: 1.8;
    margin-bottom: 1.5rem;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-top: 2rem;
`;

const StatItem = styled.div`
  text-align: center;
  padding: 2rem 1.5rem;
  background: ${({ theme }) => theme.colors.black};
  color: white;
  border-radius: 0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: ${({ theme }) => theme.transitions.default};
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  }
  
  h3 {
    font-size: 2.5rem;
    color: ${({ theme }) => theme.colors.accent};
    margin-bottom: 0.5rem;
    font-weight: 700;
  }
  
  p {
    color: white;
    font-weight: 400;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 0.875rem;
  }
`;

const ImageContainer = styled.div`
  position: relative;
`;

const AboutImage = styled.div`
  width: 100%;
  height: 400px;
  background: url('https://images.unsplash.com/photo-1547036967-23d11aacaee0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80') center/cover no-repeat;
  border-radius: 0;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  position: relative;
  filter: grayscale(100%) contrast(1.1);
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, rgba(0,0,0,0.2) 0%, rgba(255,107,107,0.1) 100%);
  }
`;

const About = () => {
  return (
    <AboutSection id="about" className="section">
      <div className="container">
        <AboutContent>
          <TextContent>
            <h2>O Adara Dance Studio</h2>
            <p>
              Adara Dance Studio to profesjonalna szkoła tańca z siedzibą w Zielonej Górze, 
              specjalizująca się w nauczaniu różnych styli tanecznych. 
              Nasz zespół składa się z doświadczonych instruktorów i choreografów, 
              którzy łączą pasję z profesjonalizmem.
            </p>
            <p>
              Wierzymy, że taniec to uniwersalny język, który pozwala wyrazić emocje 
              i opowiedzieć historię poprzez ruch. Nasze podejście opiera 
              się na indywidualnym podejściu do każdego ucznia i rozwijaniu jego naturalnych predyspozycji.
            </p>
            <StatsGrid>
              <StatItem>
                <h3>200+</h3>
                <p>Uczniów rocznie</p>
              </StatItem>
              <StatItem>
                <h3>8+</h3>
                <p>Lat doświadczenia</p>
              </StatItem>
              <StatItem>
                <h3>15+</h3>
                <p>Styli tańca</p>
              </StatItem>
              <StatItem>
                <h3>50+</h3>
                <p>Występów rocznie</p>
              </StatItem>
            </StatsGrid>
          </TextContent>
          <ImageContainer>
            <AboutImage />
          </ImageContainer>
        </AboutContent>
      </div>
    </AboutSection>
    
  );
};

export default About;

